import { useStickyElement } from '@/service/hooks/useStickyElement';
import { useWindowWidth } from '@/service/hooks/useWindowWidth';
import { cn } from '@/service/utils/cn';
import { ETripView } from '@/domain/Activities.domain';
import { CalendarIcon } from '../Icons/Calendar';
import { BrowseIcon } from '../Icons/Browse';

type TUnderscoreBtn = {
    title: ETripView;
    isActive: boolean;
    onClick: () => void;
    className?: string;
};

const Icon = {
    [ETripView.BROWSE_BY_ACTIVITY]: BrowseIcon,
    [ETripView.CALENDAR]: CalendarIcon,
    [ETripView.MOBILE_ACTIVITY]: BrowseIcon,
    [ETripView.SEARCH_DATE]: BrowseIcon,
};

export const UnderscoreBtn = ({ title, isActive, className, onClick }: TUnderscoreBtn) => {
    const { desktop, tablet, mobile } = useWindowWidth();

    const topPosition = desktop ? 32 : tablet ? 80 : mobile ? 64 : 0;

    const { stickyElementRef, isSticky } = useStickyElement(topPosition);

    const provideStyles = isSticky && desktop;

    return (
        <div
            ref={stickyElementRef}
            onClick={onClick}
            className={cn(
                `relative flex w-full max-w-[106px] cursor-pointer items-center justify-center px-2 pb-3 md:min-w-[200px] lg:min-w-[210px]
                 ${
                     provideStyles
                         ? `h-[35px] rounded-[50px] p-0 ${
                               isActive
                                   ? 'border-[1.6px] border-blue-4 bg-ash text-brand dark:bg-blue-dark'
                                   : 'text-blue-7'
                           }`
                         : `tx-large-semibold ${
                               isActive
                                   ? 'text-brand dark:text-brand'
                                   : 'text-gray-2 dark:text-gray-3'
                           }
                         `
                 }`,
                className
            )}
        >
            {Icon[title]({
                className: `h-6 w-6 mr-2 ${
                    provideStyles
                        ? `${
                              isActive
                                  ? '[&>*]:fill-brand [&>*]:stroke-brand'
                                  : 'fill-blue-7 stroke-blue-7'
                          }`
                        : isActive
                          ? 'fill-brand dark:fill-brand [&>*]:stroke-brand [&>*]:dark:stroke-brand'
                          : 'dark:fill-gray-3 dark:stroke-gray-3'
                }`,
            })}
            {title}
            <div
                className={`line absolute bottom-[5px] left-0 h-[3px] w-full rounded-md ${
                    provideStyles
                        ? 'hidden'
                        : isActive
                          ? 'bg-brand shadow-underline'
                          : 'bg-gray-3 dark:bg-dark-1'
                }`}
            />
        </div>
    );
};
